export default "__VITE_ASSET__1WLyrx4L__ 400w, __VITE_ASSET__Cp2i_jGx__ 800w, __VITE_ASSET__DHaPUiiW__ 1024w";